"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const core_ui_1 = require("@sierralabs/core-ui");
const entity_ui_1 = require("@sierralabs/entity-ui");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const QueryContext_1 = require("../QueryContext");
const QueryDataSource_1 = __importDefault(require("../QueryDataSource"));
const QueryEditPanel_1 = __importDefault(require("./QueryEditPanel"));
const QueryListPanel_1 = __importDefault(require("./QueryListPanel"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  .editor-container {
    flex: 1;
  }
  .navigation-pane {
    min-width: 240px;
  }
  .flex {
    flex: 1;
  }
`;
const QueryEditor = () => {
    const { queryId } = (0, react_router_dom_1.useParams)();
    const { queryBuilderPlugins, getQueryGroups } = (0, QueryContext_1.useQueryContext)();
    return (react_1.default.createElement(entity_ui_1.EntityProvider, null,
        react_1.default.createElement(QueryBuilderContext_1.QueryBuilderProvider, { plugins: queryBuilderPlugins },
            react_1.default.createElement(QueryDataSource_1.default, { onUpdatedQueryName: () => {
                    getQueryGroups();
                } },
                react_1.default.createElement(StyledDiv, { className: 'query-editor' },
                    react_1.default.createElement(core_ui_1.SplitPane, { className: 'editor-container' },
                        react_1.default.createElement(core_ui_1.SplitPane, { width: 240, primary: 'next', className: 'navigation-pane' },
                            react_1.default.createElement(core_ui_1.SplitPane, { direction: 'vertical', className: 'query-list-pane' },
                                react_1.default.createElement(QueryListPanel_1.default, null))),
                        react_1.default.createElement(core_ui_1.SplitPane, { className: 'query-pane' },
                            react_1.default.createElement(QueryEditPanel_1.default, null))))))));
};
exports.QueryEditor = QueryEditor;
exports.default = exports.QueryEditor;
//# sourceMappingURL=QueryEditor.js.map